class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItems =
        this.closest('cart-items') ||
        this.closest('cart-drawer-items');

      if (!cartItems) return;

      const line = parseInt(this.dataset.index, 10);

      if (!Number.isInteger(line) || line < 1) {
        return;
      }

      // 削除時は quantity = 0
      cartItems.updateQuantity(line, 0, null);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener(
      'change',
      debouncedOnChange.bind(this)
    );
  }

  cartUpdateUnsubscriber = undefined;


  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === 'cart-items') {
          return;
        }

        this.onCartUpdate();
      }
    );
  }


  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }


  onChange(event) {
    const target = event.target;

    if (!target.dataset.index) {
      return;
    }

    const line = parseInt(target.dataset.index, 10);
    const quantity = parseInt(target.value, 10);

    if (
      !Number.isInteger(line) ||
      !Number.isInteger(quantity) ||
      line < 1 ||
      quantity < 0
    ) {
      return;
    }

    this.updateQuantity(
      line,
      quantity,
      target.getAttribute('name')
    );
  }


  onCartUpdate() {
    fetch(
      `${routes.cart_url}?section_id=main-cart-items`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );

        const sourceQty =
          html.querySelector('cart-items');

        if (!sourceQty) {
          return;
        }

        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }


  getSectionsToRender() {
    const sections = [];

    const mainCartItems =
      document.getElementById('main-cart-items');

    const mainCartFooter =
      document.getElementById('main-cart-footer');

    if (mainCartItems) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents'
      });
    }

    sections.push({
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    });

    sections.push({
      id: 'cart-live-region-text',
      section: 'cart-live-region-text',
      selector: '.shopify-section'
    });

    if (mainCartFooter) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.js-contents'
      });
    }

    return sections;
  }


  updateQuantity(line, quantity, name) {
    // 念のためupdateQuantity側でも整数化
    line = parseInt(line, 10);
    quantity = parseInt(quantity, 10);

    if (
      !Number.isInteger(line) ||
      !Number.isInteger(quantity) ||
      line < 1 ||
      quantity < 0
    ) {
      return;
    }

    this.enableLoading(line);

    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: this.getSectionsToRender().map(
        (section) => section.section
      ),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        const quantityElement =
          document.getElementById(
            `Quantity-${line}`
          ) ||
          document.getElementById(
            `Drawer-quantity-${line}`
          );

        const items =
          document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value =
              quantityElement.getAttribute('value');
          }

          this.updateLiveRegions(
            line,
            parsedState.errors
          );

          return;
        }

        this.classList.toggle(
          'is-empty',
          parsedState.item_count === 0
        );

        const cartDrawerWrapper =
          document.querySelector('cart-drawer');

        const cartFooter =
          document.getElementById(
            'main-cart-footer'
          );

        if (cartFooter) {
          cartFooter.classList.toggle(
            'is-empty',
            parsedState.item_count === 0
          );
        }

        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.toggle(
            'is-empty',
            parsedState.item_count === 0
          );
        }

        this.getSectionsToRender().forEach(
          (section) => {
            const sectionElement =
              document.getElementById(section.id);

            if (!sectionElement) {
              return;
            }

            const elementToReplace =
              sectionElement.querySelector(
                section.selector
              ) ||
              sectionElement;

            const sectionHtml =
              parsedState.sections[
                section.section
              ];

            if (!sectionHtml) {
              return;
            }

            elementToReplace.innerHTML =
              this.getSectionInnerHTML(
                sectionHtml,
                section.selector
              );
          }
        );

        const updatedValue =
          parsedState.items[line - 1]
            ? parsedState.items[line - 1]
                .quantity
            : undefined;

        let message = '';

        if (
          quantityElement &&
          items.length ===
            parsedState.items.length &&
          updatedValue !==
            parseInt(
              quantityElement.value,
              10
            )
        ) {
          if (
            typeof updatedValue ===
            'undefined'
          ) {
            message =
              window.cartStrings.error;
          } else {
            message =
              window.cartStrings.quantityError.replace(
                '[quantity]',
                updatedValue
              );
          }
        }

        this.updateLiveRegions(
          line,
          message
        );

        const lineItem =
          document.getElementById(
            `CartItem-${line}`
          ) ||
          document.getElementById(
            `CartDrawer-Item-${line}`
          );

        if (
          name &&
          lineItem &&
          lineItem.querySelector(
            `[name="${name}"]`
          )
        ) {
          const target =
            lineItem.querySelector(
              `[name="${name}"]`
            );

          if (cartDrawerWrapper) {
            trapFocus(
              cartDrawerWrapper,
              target
            );
          } else {
            target.focus();
          }
        } else if (
          parsedState.item_count === 0 &&
          cartDrawerWrapper
        ) {
          const emptyInner =
            cartDrawerWrapper.querySelector(
              '.drawer__inner-empty'
            );

          const emptyLink =
            cartDrawerWrapper.querySelector(
              '.drawer__inner-empty a'
            );

          if (emptyInner && emptyLink) {
            trapFocus(
              emptyInner,
              emptyLink
            );
          }
        } else if (
          document.querySelector(
            '.cart-item'
          ) &&
          cartDrawerWrapper
        ) {
          const firstItemName =
            document.querySelector(
              '.cart-item__name'
            );

          if (firstItemName) {
            trapFocus(
              cartDrawerWrapper,
              firstItemName
            );
          }
        }

        publish(
          PUB_SUB_EVENTS.cartUpdate,
          {
            source: 'cart-items'
          }
        );
      })
      .catch((error) => {
        console.error(error);

        this.querySelectorAll(
          '.loading-overlay'
        ).forEach((overlay) => {
          overlay.classList.add(
            'hidden'
          );
        });

        const errors =
          document.getElementById(
            'cart-errors'
          ) ||
          document.getElementById(
            'CartDrawer-CartErrors'
          );

        if (errors) {
          errors.textContent =
            window.cartStrings.error;
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }


  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(
        `Line-item-error-${line}`
      ) ||
      document.getElementById(
        `CartDrawer-LineItemError-${line}`
      );

    if (
      lineItemError &&
      lineItemError.querySelector(
        '.cart-item__error-text'
      )
    ) {
      lineItemError.querySelector(
        '.cart-item__error-text'
      ).innerHTML = message;
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute(
        'aria-hidden',
        true
      );
    }

    const cartStatus =
      document.getElementById(
        'cart-live-region-text'
      ) ||
      document.getElementById(
        'CartDrawer-LiveRegionText'
      );

    if (!cartStatus) {
      return;
    }

    cartStatus.setAttribute(
      'aria-hidden',
      false
    );

    setTimeout(() => {
      cartStatus.setAttribute(
        'aria-hidden',
        true
      );
    }, 1000);
  }


  getSectionInnerHTML(html, selector) {
    const parsedHtml =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const element =
      parsedHtml.querySelector(selector);

    return element
      ? element.innerHTML
      : '';
  }


  enableLoading(line) {
    const mainCartItems =
      document.getElementById(
        'main-cart-items'
      ) ||
      document.getElementById(
        'CartDrawer-CartItems'
      );

    if (mainCartItems) {
      mainCartItems.classList.add(
        'cart__items--disabled'
      );
    }

    const cartItemElements =
      this.querySelectorAll(
        `#CartItem-${line} .loading-overlay`
      );

    const cartDrawerItemElements =
      this.querySelectorAll(
        `#CartDrawer-Item-${line} .loading-overlay`
      );

    [
      ...cartItemElements,
      ...cartDrawerItemElements
    ].forEach((overlay) => {
      overlay.classList.remove(
        'hidden'
      );
    });

    if (
      document.activeElement &&
      typeof document.activeElement.blur ===
        'function'
    ) {
      document.activeElement.blur();
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute(
        'aria-hidden',
        false
      );
    }
  }


  disableLoading(line) {
    const mainCartItems =
      document.getElementById(
        'main-cart-items'
      ) ||
      document.getElementById(
        'CartDrawer-CartItems'
      );

    if (mainCartItems) {
      mainCartItems.classList.remove(
        'cart__items--disabled'
      );
    }

    const cartItemElements =
      this.querySelectorAll(
        `#CartItem-${line} .loading-overlay`
      );

    const cartDrawerItemElements =
      this.querySelectorAll(
        `#CartDrawer-Item-${line} .loading-overlay`
      );

    cartItemElements.forEach(
      (overlay) => {
        overlay.classList.add(
          'hidden'
        );
      }
    );

    cartDrawerItemElements.forEach(
      (overlay) => {
        overlay.classList.add(
          'hidden'
        );
      }
    );
  }
}


customElements.define(
  'cart-items',
  CartItems
);


if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({
              note: event.target.value
            });

            fetch(
              `${routes.cart_update_url}`,
              {
                ...fetchConfig(),
                body
              }
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}